import AccordionEdit from "./accordion/AccordionEdit"
import TabsEdit from "./tabs/TabsEdit"

const propsAreEqual = (prevProps, nextProps) => {
  if (nextProps.data !== prevProps.data) return false
  if (nextProps.layout !== prevProps.layout) return false
  return true
}

// const CardsEdit = React.memo(props => {
const CardsEdit = (props) => {
  const { layout } = props

  if (layout === "accordion") {
    return <AccordionEdit {...props} />
  }

  if (layout === "tabs") {
    return <TabsEdit {...props} />
  }

  return null
  // }, propsAreEqual)
}

export default CardsEdit
